import "core-js/modules/web.dom.iterable";
import Vue from 'vue';
import store from "./store";
Vue.mixin({
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    var _this = this;

    if (this.$route.meta.keepAlive === true) {
      var result = this.$route.meta.keepAlive === true && store.state.tags.tagList.some(function (ele) {
        return ele.value === _this.$route.fullPath;
      });

      if (this.$vnode && !result) {
        if (this.$vnode.parent && this.$vnode.parent.componentInstance && this.$vnode.parent.componentInstance.cache) {
          if (this.$vnode.componentOptions) {
            var key = this.$vnode.key == null ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? "::".concat(this.$vnode.componentOptions.tag) : '') : this.$vnode.key;
            var cache = this.$vnode.parent.componentInstance.cache;
            var keys = this.$vnode.parent.componentInstance.keys;

            if (cache[key]) {
              if (keys.length) {
                var index = keys.indexOf(key);

                if (index > -1) {
                  keys.splice(index, 1);
                }
              }

              delete cache[key];
            }
          }
        }
      }
    }

    next();
  }
});